import produce from "immer";
import * as actionTypes from "../actions/actionTypes";

const initialState = {
  json: null,
  loaded: false,
  error: null,
};

export default produce((draft, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.SET_JSON:
      draft.json = payload;
      return;
    case actionTypes.SET_LOADED:
      draft.loaded = payload;
      return;
    case actionTypes.SET_ERROR:
      draft.error = payload;
      return;
    default:
      return;
  }
}, initialState);
